import { render, staticRenderFns } from "./CustomersContacts.vue?vue&type=template&id=0c4dd2bb&scoped=true"
import script from "./CustomersContacts.vue?vue&type=script&lang=js"
export * from "./CustomersContacts.vue?vue&type=script&lang=js"
import style0 from "./CustomersContacts.vue?vue&type=style&index=0&id=0c4dd2bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4dd2bb",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QIcon});
